import React, { useState } from 'react';
import { Modal, Spinner, ErrorBanner, EmptyState } from '../../components/ui';
import { useFetch } from '../../hooks/useFetch';
import { fmt, errMsg } from '../../utils/format';
import api from '../../utils/api';

const sourceLabel = {
  manual: 'Manual adjustment',
  manual_edit: 'Manual edit',
  shopify_sync: 'Shopify sync',
  shopify_push: 'Pushed to Shopify',
  shopify_order_edit: 'Order edit',
  shopify_refund: 'Refund restock',
  work_order: 'Work order',
  receiving: 'Receiving',
  rma: 'RMA / Return',
  ai_panel: 'AI panel',
  third_party: 'Feed sync',
};

export default function ProductAdjustmentLogModal({ product, onClose }) {
  const { data, loading, error, refetch } = useFetch(`/api/adjustments?entityType=product&entityId=${product.id}&limit=100`);
  const [pulling, setPulling] = useState(null);

  const pullInventory = async (row) => {
    if (row.qty_after == null) { alert('No quantity value to restore'); return; }
    if (!window.confirm(`Set inventory to ${fmt.number(row.qty_after)}? This will record a manual adjustment.`)) return;
    setPulling(row.id);
    try {
      await api.patch(`/api/products/${product.id}`, {
        quantityOnHand: row.qty_after,
        reason: `Restored to ${fmt.number(row.qty_after)} from inventory log (entry from ${fmt.dateTime(row.created_at)})`,
      });
      refetch();
    } catch (err) { alert(errMsg(err)); }
    finally { setPulling(null); }
  };

  return (
    <Modal title={`Inventory log — ${product.name}`} onClose={onClose} wide
      footer={<button className="btn" onClick={onClose}>Close</button>}>
      {loading && <Spinner />}
      {error && <ErrorBanner message={error} />}
      {data && (
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Date</th>
                <th>Change</th>
                <th>Qty after</th>
                <th>Source</th>
                <th>Reason</th>
                <th>By</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {data.map(a => (
                <tr key={a.id}>
                  <td style={{ fontSize:12, whiteSpace:'nowrap' }}>{fmt.dateTime(a.created_at)}</td>
                  <td style={{ fontWeight:600, color: a.quantity_delta >= 0 ? 'var(--color-success)' : 'var(--color-danger)' }}>
                    {a.quantity_delta >= 0 ? '+' : ''}{fmt.number(a.quantity_delta)}
                  </td>
                  <td style={{ fontWeight: 500 }}>{a.qty_after != null ? fmt.number(a.qty_after) : '—'}</td>
                  <td><span className="badge" style={{ fontSize:10 }}>{sourceLabel[a.source] || a.source}</span></td>
                  <td style={{ fontSize:12 }}>{a.reason}</td>
                  <td style={{ fontSize:12 }}>{a.performed_by_name || (a.source === 'manual' || a.source === 'manual_edit' ? '—' : 'System')}</td>
                  <td>
                    {a.qty_after != null && (
                      <button
                        className="btn btn-sm"
                        title={`Restore qty to ${fmt.number(a.qty_after)}`}
                        disabled={pulling === a.id}
                        onClick={() => pullInventory(a)}
                        style={{ whiteSpace: 'nowrap' }}
                      >
                        <i className="ti ti-history-toggle" /> {pulling === a.id ? '…' : fmt.number(a.qty_after)}
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {!data.length && <EmptyState icon="ti-history" message="No inventory changes recorded yet" />}
        </div>
      )}
    </Modal>
  );
}
